import apiClient from '@utils/apiClient';
import {
    WeatherScheduleLogListReq,
    WeatherScheduleLogListRes,
} from '@/api/weather/log/type';
import { ApiResult } from '@/api/common/type';

export const api = {
    /**
     * 기상 스케줄 로그 목록
     * @param param
     */
    weatherScheduleLogList: async (
        param: WeatherScheduleLogListReq,
    ): Promise<WeatherScheduleLogListRes> => {
        const response = await apiClient.post<WeatherScheduleLogListRes>(
            '/api/v1/weather/schedule/log/list',
            param,
        );
        return response.data;
    },

    /**
     * 기상 데이터 갱신
     */
    updateWeather: async (): Promise<ApiResult> => {
        const response = await apiClient.get<ApiResult>(
            '/api/v1/weather/update',
        );
        return response.data;
    },
};
